export default {
  GET_ALL_SECURITYCATEGORIES: 'getAllSecurityCategories',
  SAVE_SECURITYCATEGORY: 'saveSecurityCategory',
  UPDATE_SECURITYCATEGORY: 'updateSecurityCategory',
  DELETE_SECURITYCATEGORY: 'deleteSecurityCategory'
}
